import { componentCategoryData } from './component-category.data';
import { ComponentOptions } from '../types';
import { Rules } from '../../blueprint-classes';
import { ComponentCategoryData, ComponentCategoryDataIn } from './types';

export class ComponentCategory {
	#id: string;

	readonly key: string;
	readonly rules: Rules;
	readonly defaultPlacement: string | null;

	public description: string;
	public active: boolean;
	public sort: number;

	constructor (options: ComponentOptions<ComponentCategoryDataIn>) {
		const data = componentCategoryData(options.dataIn ?? null);

		this.#id = data.id;
		this.key = data.key;
		this.description = data.description;
		this.rules = data.rules;
		this.active = data.active;
		this.sort = data.sort;
		this.defaultPlacement = data.defaultPlacement;
	}

	get id (): string { return this.#id }
	get isVent (): boolean { return this.key === 'vent' }
	get isPassthrough (): boolean { return this.key === 'passthrough' }
	get isSpacer (): boolean { return this.key === 'spacer' }
	get isInsulatedJacket (): boolean { return this.key === 'insulated-jacket' }
	get isGrillOrSideBurner (): boolean { return ['Grills', 'Side Burners'].indexOf(this.description) > -1 }
	get isFridge (): boolean { return this.description === 'Fridges' }
	get isOutlet (): boolean { return this.key === 'outlet' }
	get isHole (): boolean { return this.key === 'hole' }
	get isUtilityCutout (): boolean { return this.key === 'utility-cutout' }

	public serialize ():ComponentCategoryData {
		return {
			id: this.#id,
			key: this.key,
			description: this.description,
			rules: this.rules,
			active: this.active,
			sort: this.sort,
			defaultPlacement: this.defaultPlacement
		};
	}
}
